/** Calculate scrollbar width and update css property */
export default function calculateScrollBarWidth(CSSproperty) {
  document.documentElement.style.setProperty(CSSproperty, `${window.innerWidth - document.documentElement.clientWidth}px`);
}
